// src/components/product/BundleEditor/BundleCheckbox.jsx
import React from 'react';
import { CheckSquare, Square } from 'lucide-react';
import styles from './BundleEditor.module.css';

// DataTable-style icon checkbox; the hidden native input keeps keyboard and label behaviour.
const BundleCheckbox = ({ checked, onChange, label = null, className = '' }) => (
  <label className={`${styles.checkboxLabel} ${className}`}>
    <input type="checkbox" className={styles.srOnly} checked={!!checked} onChange={onChange} />
    <span className={`${styles.checkboxIcon} ${checked ? styles.checkboxChecked : ''}`}>
      {checked ? <CheckSquare size={18} /> : <Square size={18} />}
    </span>
    {label}
  </label>
);

export default BundleCheckbox;
